"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionGroupEnum = exports.BUSINESS_DISCUSSIONS_EDIT = exports.BUSINESS_DISCUSSIONS_VIEW = exports.BUSINESS_DISCUSSIONS_VIEW_SELF = exports.BUSINESS_DISCUSSIONS_PUBLISH = exports.BUSINESS_DISCUSSIONS_APPROVE = exports.BUSINESS_DISCUSSIONS_CREATE = exports.APPLICATION_VIEW = exports.SCHEDULE_DELETE = exports.SCHEDULE_VIEW_ALL = exports.SCHEDULE_VIEW = exports.SCHEDULE_UPLOAD = exports.FINANCIAL_WEEKLY_PAYROLL = exports.FINANCIAL_RECEIPT_VIEW = exports.FINANCIAL_RECEIPT_DELETE = exports.FINANCIAL_RECEIPT_UPLOAD = exports.WORK_ORDER_SUPPLIER_DELETE = exports.WORK_ORDER_SUPPLIER_EDIT = exports.WORK_ORDER_SUPPLIER_VIEW = exports.WORK_ORDER_SUPPLIER_CREATE = exports.WORK_ORDER_DELETE = exports.WORK_ORDER_EDIT = exports.WORK_ORDER_VIEW = exports.WORK_ORDER_CREATE = exports.PD_RUN_SHEETS_APPROVE = exports.PD_RUN_SHEETS_EDIT = exports.PD_RUN_SHEETS_DELETE = exports.PD_RUN_SHEETS_CREATE = exports.PD_RUN_SHEETS_LIST = exports.PD_RUN_SHEETS_RECAP = exports.PD_RUN_SHEETS_SUBMIT = exports.PD_DELETE_TRUCKS = exports.PD_EDIT_TRUCKS = exports.PD_CREATE_TRUCKS = exports.PD_VIEW_TRUCKS = exports.LINEHAUL_VIEW_SHIFTS = exports.LINEHAUL_VIEW_TRUCKS = exports.LINEHAUL_VIEW_LOCATIONS = exports.ROLE_DELETE = exports.ROLE_EDIT = exports.ROLE_CREATE = exports.ROLE_VIEW = exports.ACCOUNT_DELETE = exports.ACCOUNT_VIEW = exports.ACCOUNT_EDIT = exports.ACCOUNT_CREATE = exports.ACCOUNT_LOGIN = exports.ADMINISTRATOR = exports.ROLE_DESCRITPIONS = exports.MAX_BITS = void 0;
exports.ParseRolePermissions = exports.DigiTrakRole = exports.Permissions = void 0;
const perms_1 = require("@pstl/perms");
// see Number.MAX_SAFE_INTEGER
exports.MAX_BITS = 53 - 1;
// Role descriptions
exports.ROLE_DESCRITPIONS = {
    ADMINISTRATOR: "Grants a user administrative access (all permissions allowed).",
    ACCOUNT_LOGIN: "Allows a user to login to the application. Also gives acces to: verifying email, submiting bug report, updating one's own settings.",
    ACCOUNT_CREATE: "Allows a user create an account.",
    ACCOUNT_EDIT: "Allows a user to edit a user's account. Also gives access to: resending verify email, reseting other account's password.",
    ACCOUNT_VIEW: "Allows a user to view the accounts list page. Also gives to acces a limited single account view (general, driver, emergency contact).",
    ACCOUNT_DELETE: "Allows a user to delete an account.",
    ROLE_VIEW: "Allows a user to view the roles list page.",
    ROLE_CREATE: "Allows a user create a role.",
    ROLE_EDIT: "Allows a user to edit a role's permissions (but not their own, or a higher tier).",
    ROLE_DELETE: "Allows a user to delete a role (but not their own, or a higher tier).",
    LINEHAUL_VIEW_LOCATIONS: "Allows a user to view the linehaul location page (currently unused).",
    LINEHAUL_VIEW_SHIFTS: "Allows a user to view a linehaul truck (currently unused).",
    LINEHAUL_VIEW_TRUCKS: "Allows a user to view linehaul shifts (currently unused).",
    PD_VIEW_TRUCKS: "Allows a user to view all P&D trucks. Does not affect viewing trucks in run sheets or work orders.",
    PD_CREATE_TRUCKS: "Allows a user to create a P&D truck.",
    PD_EDIT_TRUCKS: "Allows a user to edit a P&D truck.",
    PD_DELETE_TRUCKS: "Allows a user to delete a P&D truck.",
    PD_RUN_SHEETS_SUBMIT: "Allows a user fill out and submit a run sheet.",
    PD_RUN_SHEETS_RECAP: "Allows a user to view the submitted run sheets.",
    PD_RUN_SHEETS_LIST: "Allows a user to see their current run sheets.",
    PD_RUN_SHEETS_CREATE: "Allows a user to create run sheets.",
    PD_RUN_SHEETS_DELETE: "Allows a user to delete a run sheet. Will not allow deletion of a submitted run sheet.",
    PD_RUN_SHEETS_EDIT: "Allows a user to edit or delete another run sheet.",
    PD_RUN_SHEETS_APPROVE: "Allows a user to approve/reject a run sheet. Also gives ability to add notes.",
    APPLICATION_VIEW: "Allows a user to view applications (currently unused).",
    WORK_ORDER_CREATE: "Allows a user to create a work order.",
    WORK_ORDER_VIEW: "Allows a user to view work orders.",
    WORK_ORDER_EDIT: "Allows a user to edit a work order. Required to make any changes to a work order (adding notes, changing status, etc.).",
    WORK_ORDER_DELETE: "Allows a user to delete a work order.",
    WORK_ORDER_SUPPLIER_CREATE: "Allows a user to create a supplier.",
    WORK_ORDER_SUPPLIER_VIEW: "Allows a user to view suppliers.",
    WORK_ORDER_SUPPLIER_EDIT: "Allows a user to edit a supplier.",
    WORK_ORDER_SUPPLIER_DELETE: "Allows a user to delete a supplier.",
    FINANCIAL_RECEIPT_UPLOAD: "Allows a user to upload a receipt.",
    FINANCIAL_RECEIPT_DELETE: "Allows a user to delete a receipt.",
    FINANCIAL_RECEIPT_VIEW: "Allows a user to view expenses.",
    FINANCIAL_WEEKLY_PAYROLL: "Allows a user to view weekly payroll.",
    SCHEDULE_UPLOAD: "Allows a user to upload a schedule.",
    SCHEDULE_VIEW: "Allows a user to view schedules.",
    SCHEDULE_VIEW_ALL: "Allows a user to view all schedules.",
    SCHEDULE_DELETE: "Allows a user to delete a schedule.",
    BUSINESS_DISCUSSIONS_CREATE: "Allows a user to create a business discussion.",
    BUSINESS_DISCUSSIONS_APPROVE: "Allows a user to approve business discussions.",
    BUSINESS_DISCUSSIONS_PUBLISH: "Allows a user to publish a business discussion.",
    BUSINESS_DISCUSSIONS_VIEW_SELF: "Allows a user to view their own submtited business discussions.",
    BUSINESS_DISCUSSIONS_VIEW: "Allows a user to to view all business discussions.",
    BUSINESS_DISCUSSIONS_EDIT: "Allows a user to to edit a business discussions (add notes, etc).",
};
// Admin
exports.ADMINISTRATOR = (0, perms_1.Shift)(exports.MAX_BITS);
// Account
exports.ACCOUNT_LOGIN = (0, perms_1.Shift)(0);
exports.ACCOUNT_CREATE = (0, perms_1.Shift)(1);
exports.ACCOUNT_EDIT = (0, perms_1.Shift)(2);
exports.ACCOUNT_VIEW = (0, perms_1.Shift)(3);
exports.ACCOUNT_DELETE = (0, perms_1.Shift)(29);
// Roles
exports.ROLE_VIEW = (0, perms_1.Shift)(4);
exports.ROLE_CREATE = (0, perms_1.Shift)(5);
exports.ROLE_EDIT = (0, perms_1.Shift)(6);
exports.ROLE_DELETE = (0, perms_1.Shift)(7);
// Onboarding
// export const ONBOARDING_VIEW: number = Shift( 9 );
// export const ONBOARDING_GENERATE: number = Shift( 10 );
// export const ONBOARDING_NEW_ACCOUNT: number = Shift( 29 );
// Linehaul
exports.LINEHAUL_VIEW_LOCATIONS = (0, perms_1.Shift)(11);
exports.LINEHAUL_VIEW_TRUCKS = (0, perms_1.Shift)(18);
exports.LINEHAUL_VIEW_SHIFTS = (0, perms_1.Shift)(19);
// P&D
exports.PD_VIEW_TRUCKS = (0, perms_1.Shift)(12);
exports.PD_CREATE_TRUCKS = (0, perms_1.Shift)(13);
exports.PD_EDIT_TRUCKS = (0, perms_1.Shift)(14);
exports.PD_DELETE_TRUCKS = (0, perms_1.Shift)(15);
exports.PD_RUN_SHEETS_SUBMIT = (0, perms_1.Shift)(16);
exports.PD_RUN_SHEETS_RECAP = (0, perms_1.Shift)(17);
exports.PD_RUN_SHEETS_LIST = (0, perms_1.Shift)(25);
exports.PD_RUN_SHEETS_CREATE = (0, perms_1.Shift)(26);
exports.PD_RUN_SHEETS_DELETE = (0, perms_1.Shift)(27);
exports.PD_RUN_SHEETS_EDIT = (0, perms_1.Shift)(28);
exports.PD_RUN_SHEETS_APPROVE = (0, perms_1.Shift)(10);
// Work Order
exports.WORK_ORDER_CREATE = (0, perms_1.Shift)(21);
exports.WORK_ORDER_VIEW = (0, perms_1.Shift)(22);
exports.WORK_ORDER_EDIT = (0, perms_1.Shift)(23);
exports.WORK_ORDER_DELETE = (0, perms_1.Shift)(24);
exports.WORK_ORDER_SUPPLIER_CREATE = (0, perms_1.Shift)(32);
exports.WORK_ORDER_SUPPLIER_VIEW = (0, perms_1.Shift)(33);
exports.WORK_ORDER_SUPPLIER_EDIT = (0, perms_1.Shift)(34);
exports.WORK_ORDER_SUPPLIER_DELETE = (0, perms_1.Shift)(35);
// Financial
exports.FINANCIAL_RECEIPT_UPLOAD = (0, perms_1.Shift)(36);
exports.FINANCIAL_RECEIPT_DELETE = (0, perms_1.Shift)(9);
exports.FINANCIAL_RECEIPT_VIEW = (0, perms_1.Shift)(37);
exports.FINANCIAL_WEEKLY_PAYROLL = (0, perms_1.Shift)(38);
// Schedules
exports.SCHEDULE_UPLOAD = (0, perms_1.Shift)(30);
exports.SCHEDULE_VIEW = (0, perms_1.Shift)(31);
exports.SCHEDULE_VIEW_ALL = (0, perms_1.Shift)(39);
exports.SCHEDULE_DELETE = (0, perms_1.Shift)(40);
// Application
exports.APPLICATION_VIEW = (0, perms_1.Shift)(20);
// Business Discussions
exports.BUSINESS_DISCUSSIONS_CREATE = (0, perms_1.Shift)(41);
exports.BUSINESS_DISCUSSIONS_APPROVE = (0, perms_1.Shift)(42);
exports.BUSINESS_DISCUSSIONS_PUBLISH = (0, perms_1.Shift)(43);
exports.BUSINESS_DISCUSSIONS_VIEW_SELF = (0, perms_1.Shift)(44);
exports.BUSINESS_DISCUSSIONS_VIEW = (0, perms_1.Shift)(45);
exports.BUSINESS_DISCUSSIONS_EDIT = (0, perms_1.Shift)(46);
// ------------------------
/**
 * Naming convention for permissions:
 * [feature]_[action]
 * ex1: account_create - [feature]_[action]
 *
 * If there are "sub" features to a permission group do the following:
 * [feature]_[sub_feature]_[action]
 * ex2: work_order_supplier_create - [feature]_[sub_feature]_[action]
 *
 * This convention follows for any degree of sub features:
 * [feature]_[sub_feature]_[sub_sub_feature]_[action]
 *
 * An example of incorrect naming:
 * ex3: pd_view_trucks - [feature]_[action]_[sub_feature]
 *
 * Additionally, any plurality should be removed from the permission.
 * ex4: work_orders_create should be work_order_create
 */
var PermissionGroupEnum;
(function (PermissionGroupEnum) {
    PermissionGroupEnum["account"] = "account";
    PermissionGroupEnum["administrator"] = "administrator";
    // audit_log = "audit_log",
    // application = "application",
    PermissionGroupEnum["announcement"] = "announcement";
    PermissionGroupEnum["business_discussion"] = "business_discussion";
    PermissionGroupEnum["form"] = "form";
    PermissionGroupEnum["financial"] = "financial";
    PermissionGroupEnum["inventory"] = "inventory";
    PermissionGroupEnum["linehaul"] = "linehaul";
    PermissionGroupEnum["report"] = "report";
    PermissionGroupEnum["role"] = "role";
    PermissionGroupEnum["pd"] = "pd";
    PermissionGroupEnum["schedule"] = "schedule";
    PermissionGroupEnum["terminal"] = "terminal";
    PermissionGroupEnum["work_order"] = "work_order";
})(PermissionGroupEnum = exports.PermissionGroupEnum || (exports.PermissionGroupEnum = {}));
exports.Permissions = {
    administrator: {
        all: {
            permission: (0, perms_1.Shift)(exports.MAX_BITS),
            description: "Grants a user administrative access (all permissions allowed)."
        },
        manage_organization: {
            permission: (0, perms_1.Shift)(0),
            description: "Grants a user access to the Manage Organization page."
        }
    },
    account: {
        all: {
            permission: (0, perms_1.Shift)(exports.MAX_BITS),
            description: "Grants a user all User related permissions."
        },
        create: {
            permission: (0, perms_1.Shift)(0),
            description: "Allows a user to add a user to the organization."
        },
        delete: {
            permission: (0, perms_1.Shift)(1),
            description: "Allows a user to delete or deactivate another user."
        },
        edit: {
            permission: (0, perms_1.Shift)(2),
            description: "Allows a user to edit a user's information. Also gives access to: resending invite email"
        },
        login: {
            permission: (0, perms_1.Shift)(3),
            description: "Allows a user to login to the application. Also gives acces to: verifying email, submiting bug report, updating one's own settings."
        },
        manager: {
            permission: (0, perms_1.Shift)(5),
            description: "Designates user with this role as a Manager. Used for the \"Manager\" field under \"Job\" when creating or editing a user."
        },
        view: {
            permission: (0, perms_1.Shift)(4),
            description: "Allows a user to view the accounts list page. Also gives to acces a limited single account view (general, driver, emergency contact)."
        },
    },
    announcement: {
        all: {
            permission: (0, perms_1.Shift)(exports.MAX_BITS),
            description: "Grants a user all Announcement related permissions."
        },
        create: {
            permission: (0, perms_1.Shift)(0),
            description: "Allows a user to create an announcement."
        },
        delete: {
            permission: (0, perms_1.Shift)(1),
            description: "Allows a user to delete an announcement."
        },
        // edit: {
        //     permission: Shift(2),
        //     description: "Allows a user to edit a announcement."
        // },
        view: {
            permission: (0, perms_1.Shift)(3),
            description: "Also allows a user to view any announcement they were a recipient of in the announcement list page. This permission is required to be able to select this role as a recipient during the announcement creation process."
        },
        view_details: {
            permission: (0, perms_1.Shift)(4),
            description: "Allows a user to view more details regarding an announcement (users acknowledged)."
        },
        view_all: {
            permission: (0, perms_1.Shift)(5),
            description: "Allows a user to view the all announcements in the announcement list page."
        },
    },
    // application: {
    // },
    // audit_log: {
    // },
    business_discussion: {
        all: {
            permission: (0, perms_1.Shift)(exports.MAX_BITS),
            description: "Grants a user all Business Discussion related permissions."
        },
        approve: {
            permission: (0, perms_1.Shift)(0),
            description: "Allows a user to approve business discussions.",
        },
        // coaching: {
        //     permission: Shift(8),
        //     description: "Allows a users to create coaching discussions."
        // },
        create: {
            permission: (0, perms_1.Shift)(1),
            description: "Allows a user to create a business discussion."
        },
        // delete: {
        //     permission: Shift(2),
        //     description: "Allows a user to delete their own business discussion. Cannot delete a submitted discussion."
        // },
        delete: {
            permission: (0, perms_1.Shift)(16),
            description: "Allows a user to delete business discussions."
        },
        edit: {
            permission: (0, perms_1.Shift)(3),
            description: "Allows a user to to edit a business discussions (add notes, etc)."
        },
        edit_self: {
            permission: (0, perms_1.Shift)(10),
            description: "Allows a user to edit their own business discussion."
        },
        // formal_reprimand: {
        //     permission: Shift(7),
        //     description: "Allows a usere to create formal reprimand discussions."
        // },
        publish: {
            permission: (0, perms_1.Shift)(4),
            description: "Allows a user to publish a business discussion."
        },
        // suspension: {
        //     permission: Shift(11),
        //     description: "Allows a user to create suspension discussions."
        // },
        // termination: {
        //     permission: Shift(12),
        //     description: "Allows a user to create termination discussions."
        // },
        // verbal: {
        //     permission: Shift(9),
        //     description: "Allows a user to create verbal discussions."
        // },
        view_all: {
            permission: (0, perms_1.Shift)(5),
            description: "Allows a user to to view all business discussions."
        },
        view: {
            permission: (0, perms_1.Shift)(6),
            description: "Allows a user to view their own submtited business discussions."
        },
        category_create: {
            permission: (0, perms_1.Shift)(12),
            description: "Allows a user to create a category."
        },
        category_delete: {
            permission: (0, perms_1.Shift)(13),
            description: "Allows a user to delete (or de-activate) a category."
        },
        category_edit: {
            permission: (0, perms_1.Shift)(14),
            description: "Allows a user to edit a category."
        },
        category_view: {
            permission: (0, perms_1.Shift)(15),
            description: "Allows a user to view the category list page."
        },
        type_create: {
            permission: (0, perms_1.Shift)(7),
            description: "Allows a user to create a type."
        },
        type_delete: {
            permission: (0, perms_1.Shift)(8),
            description: "Allows a user to delete (or de-activate) a type."
        },
        type_edit: {
            permission: (0, perms_1.Shift)(9),
            description: "Allows a user to edit a type."
        },
        type_view: {
            permission: (0, perms_1.Shift)(11),
            description: "Allows a user to view the type list page."
        },
    },
    financial: {
        all: {
            permission: (0, perms_1.Shift)(exports.MAX_BITS),
            description: "Grants a user all Financial related permissions."
        },
        receipt_delete: {
            permission: (0, perms_1.Shift)(0),
            description: "Allows a user to delete a receipt."
        },
        receipt_upload: {
            permission: (0, perms_1.Shift)(1),
            description: "Allows a user to upload a receipt."
        },
        receipt_view_all: {
            permission: (0, perms_1.Shift)(2),
            description: "Allows a user to view all expenses."
        },
        receipt_view: {
            permission: (0, perms_1.Shift)(4),
            description: "Allows a user to view their submitted receipts."
        },
        weekly_payroll: {
            permission: (0, perms_1.Shift)(3),
            description: "Allows a user to view weekly payroll."
        }
    },
    form: {
        all: {
            permission: (0, perms_1.Shift)(exports.MAX_BITS),
            description: "Grants a user all Form related permissions."
        },
        approve: {
            permission: (0, perms_1.Shift)(4),
            description: "Allows a user to approve or reject a form."
        },
        create: {
            permission: (0, perms_1.Shift)(0),
            description: "Allows a user to submit a form (requires view permission)."
        },
        delete: {
            permission: (0, perms_1.Shift)(11),
            description: "Allows a user to delete a form they have submitted if it is still Awaiting Approval."
        },
        delete_other: {
            permission: (0, perms_1.Shift)(1),
            description: "Allows a user to delete other user's forms."
        },
        edit: {
            permission: (0, perms_1.Shift)(2),
            description: "Allows a user to edit a form that they have submitted if it is Awaiting Approval or Rejected."
        },
        edit_other: {
            permission: (0, perms_1.Shift)(10),
            description: "Allows a user to edit or add a note to another user's form."
        },
        view: {
            permission: (0, perms_1.Shift)(3),
            description: "Allows a user to view their submitted forms."
        },
        view_all: {
            permission: (0, perms_1.Shift)(5),
            description: "Allows a user to view all submitted forms."
        },
        type_create: {
            permission: (0, perms_1.Shift)(6),
            description: "Allows a user to create a form type."
        },
        type_delete: {
            permission: (0, perms_1.Shift)(7),
            description: "Allows a user to delete (or de-activate) a form type."
        },
        type_edit: {
            permission: (0, perms_1.Shift)(8),
            description: "Allows a user to edit a form type."
        },
        type_view: {
            permission: (0, perms_1.Shift)(9),
            description: "Allows a user to view the Form Types list page."
        }
    },
    inventory: {
        all: {
            permission: (0, perms_1.Shift)(exports.MAX_BITS),
            description: "Grants a user all Inventory related permissions."
        },
        item_create: {
            permission: (0, perms_1.Shift)(0),
            description: "Allows a user to add an item to the inventory."
        },
        item_create_many: {
            permission: (0, perms_1.Shift)(12),
            description: "Allows a user to add multiple items in a single submission to the inventory using the \"sheet\" feature."
        },
        item_delete: {
            permission: (0, perms_1.Shift)(1),
            description: "Allows a user to delete an inventory item."
        },
        item_edit: {
            permission: (0, perms_1.Shift)(2),
            description: "Allows a user to edit an inventory item."
        },
        item_view: {
            permission: (0, perms_1.Shift)(3),
            description: "Allows a user to view the inventory."
        },
        item_issue: {
            permission: (0, perms_1.Shift)(10),
            description: "Allows a user to change the issue status of an inventory item."
        },
        item_repair: {
            permission: (0, perms_1.Shift)(4),
            description: "Allows a user to set the repair status of an inventory item."
        },
        item_dispose: {
            permission: (0, perms_1.Shift)(5),
            description: "Allows a user to set the final disposition status of an inventory item."
        },
        item_missing: {
            permission: (0, perms_1.Shift)(11),
            description: "Allows a user to set the missing status of an inventory item."
        },
        type_create: {
            permission: (0, perms_1.Shift)(6),
            description: "Allows a user to create an inventory type."
        },
        type_delete: {
            permission: (0, perms_1.Shift)(7),
            description: "Allows a user to delete (or archive) an inventory type."
        },
        type_edit: {
            permission: (0, perms_1.Shift)(8),
            description: "Allows a user to edit an inventory type."
        },
        type_view: {
            permission: (0, perms_1.Shift)(9),
            description: "Allows a user to view all inventory types."
        },
    },
    linehaul: {
        all: {
            permission: (0, perms_1.Shift)(exports.MAX_BITS),
            description: "Grants a user all P&D related permissions."
        },
        assignment_create: {
            permission: (0, perms_1.Shift)(12),
            description: "Allows a user to create an assignment."
        },
        assignment_delete: {
            permission: (0, perms_1.Shift)(13),
            description: "Allows a user to delete (or de-activate) an assignment."
        },
        assignment_edit: {
            permission: (0, perms_1.Shift)(14),
            description: "Allows a user to edit an assignment."
        },
        assignment_view: {
            permission: (0, perms_1.Shift)(15),
            description: "Allows a user to view the assignment list page."
        },
        location_create: {
            permission: (0, perms_1.Shift)(16),
            description: "Allows a user to create a location."
        },
        location_delete: {
            permission: (0, perms_1.Shift)(17),
            description: "Allows a user to delete (or de-activate) a location."
        },
        location_edit: {
            permission: (0, perms_1.Shift)(18),
            description: "Allows a user to edit a location."
        },
        location_view: {
            permission: (0, perms_1.Shift)(19),
            description: "Allows a user to view the location list page."
        },
        run_sheets_approve: {
            permission: (0, perms_1.Shift)(4),
            description: "Allows a user to approve/reject a run sheet. Also gives ability to add notes."
        },
        run_sheets_create: {
            permission: (0, perms_1.Shift)(5),
            description: "Allows a user to create their own run sheets."
        },
        run_sheets_delete: {
            permission: (0, perms_1.Shift)(6),
            description: "Allows a user to delete their own run sheet. Will not allow deletion of a submitted run sheet."
        },
        run_sheets_edit: {
            permission: (0, perms_1.Shift)(7),
            description: "Allows a user to edit or delete another user's run sheet."
        },
        run_sheets_list: {
            permission: (0, perms_1.Shift)(8),
            description: "Allows a user to see their current run sheets."
        },
        run_sheets_recap: {
            permission: (0, perms_1.Shift)(9),
            description: "Allows a user to view all run sheets."
        },
        run_sheets_submit: {
            permission: (0, perms_1.Shift)(10),
            description: "Allows a user fill out and submit a run sheet."
        },
        truck_create: {
            permission: (0, perms_1.Shift)(0),
            description: "Allows a user to create a Linehaul truck."
        },
        truck_delete: {
            permission: (0, perms_1.Shift)(1),
            description: "Allows a user to delete a Linehaul truck."
        },
        truck_edit: {
            permission: (0, perms_1.Shift)(2),
            description: "Allows a user to edit a Linehaul truck."
        },
        truck_settings_edit: {
            permission: (0, perms_1.Shift)(20),
            description: "Allows a user to edit Linehaul truck settings (permits)."
        },
        truck_settings_view: {
            permission: (0, perms_1.Shift)(21),
            description: "Allows a user to view Linehaul truck settings (permits)."
        },
        truck_view: {
            permission: (0, perms_1.Shift)(3),
            description: "Allows a user to view all Linehaul trucks. Does not affect viewing trucks in run sheets or work orders."
        },
        mmr: {
            permission: (0, perms_1.Shift)(11),
            description: "Allows a user to generate MMR reports."
        }
    },
    report: {
        all: {
            permission: (0, perms_1.Shift)(exports.MAX_BITS),
            description: "Grants a user all Report related permissions."
        },
        create: {
            permission: (0, perms_1.Shift)(0),
            description: "Allows a user to create reports."
        }
    },
    role: {
        all: {
            permission: (0, perms_1.Shift)(exports.MAX_BITS),
            description: "Grants a user all Role related permissions."
        },
        create: {
            permission: (0, perms_1.Shift)(0),
            description: "Allows a user create a role."
        },
        delete: {
            permission: (0, perms_1.Shift)(1),
            description: "Allows a user to delete a role (but not their own, or a higher tier)."
        },
        edit: {
            permission: (0, perms_1.Shift)(2),
            description: "Allows a user to edit a role's permissions (but not their own, or a higher tier)."
        },
        view: {
            permission: (0, perms_1.Shift)(3),
            description: "Allows a user to view the roles list page."
        }
    },
    pd: {
        all: {
            permission: (0, perms_1.Shift)(exports.MAX_BITS),
            description: "Grants a user all P&D related permissions."
        },
        dsw_view: {
            permission: (0, perms_1.Shift)(18),
            description: "Allows a user to view Daily Service Worksheets.",
            label: "DSW View",
        },
        dsw_runner_view: {
            permission: (0, perms_1.Shift)(19),
            description: "Allows a user to view the DSW script logs.",
            label: "DSW Script Log View",
        },
        dsw_runner_start: {
            permission: (0, perms_1.Shift)(20),
            description: "Allows a user to start a DSW script.",
            label: "DSW Script Start",
        },
        dsw_runner_stop: {
            permission: (0, perms_1.Shift)(21),
            description: "Allows a user to stop a DSW script.",
            label: "DSW Script Stop",
        },
        assignment_create: {
            permission: (0, perms_1.Shift)(12),
            description: "Allows a user to create an assignment."
        },
        assignment_delete: {
            permission: (0, perms_1.Shift)(13),
            description: "Allows a user to delete (or de-activate) an assignment."
        },
        assignment_edit: {
            permission: (0, perms_1.Shift)(14),
            description: "Allows a user to edit an assignment."
        },
        assignment_view: {
            permission: (0, perms_1.Shift)(15),
            description: "Allows a user to view the assignment list page."
        },
        run_sheets_approve: {
            permission: (0, perms_1.Shift)(4),
            description: "Allows a user to approve/reject a run sheet. Also gives ability to add notes."
        },
        run_sheets_create: {
            permission: (0, perms_1.Shift)(5),
            description: "Allows a user to create their own run sheets."
        },
        run_sheets_delete: {
            permission: (0, perms_1.Shift)(6),
            description: "Allows a user to delete their own run sheet. Will not allow deletion of a submitted run sheet."
        },
        run_sheets_edit: {
            permission: (0, perms_1.Shift)(7),
            description: "Allows a user to edit or delete another user's run sheet."
        },
        run_sheets_list: {
            permission: (0, perms_1.Shift)(8),
            description: "Allows a user to see their current run sheets."
        },
        run_sheets_recap: {
            permission: (0, perms_1.Shift)(9),
            description: "Allows a user to view all run sheets."
        },
        run_sheets_submit: {
            permission: (0, perms_1.Shift)(10),
            description: "Allows a user fill out and submit a run sheet."
        },
        truck_create: {
            permission: (0, perms_1.Shift)(0),
            description: "Allows a user to create a P&D truck."
        },
        truck_delete: {
            permission: (0, perms_1.Shift)(1),
            description: "Allows a user to delete a P&D truck."
        },
        truck_edit: {
            permission: (0, perms_1.Shift)(2),
            description: "Allows a user to edit a P&D truck."
        },
        truck_view: {
            permission: (0, perms_1.Shift)(3),
            description: "Allows a user to view all P&D trucks. Does not affect viewing trucks in run sheets or work orders."
        },
        truck_settings_edit: {
            permission: (0, perms_1.Shift)(16),
            description: "Allows a user to edit Linehaul truck settings (permits)."
        },
        truck_settings_view: {
            permission: (0, perms_1.Shift)(17),
            description: "Allows a user to view Linehaul truck settings (permits)."
        },
        mmr: {
            permission: (0, perms_1.Shift)(11),
            description: "Allows a user to generate MMR reports."
        },
    },
    schedule: {
        all: {
            permission: (0, perms_1.Shift)(exports.MAX_BITS),
            description: "Grants a user all Schedule related permissions."
        },
        create: {
            permission: (0, perms_1.Shift)(0),
            description: "Allows a user to upload a schedule."
        },
        delete: {
            permission: (0, perms_1.Shift)(1),
            description: "Allows a user to delete a schedule."
        },
        group_create: {
            permission: (0, perms_1.Shift)(4),
            description: "Allows a user to create a schedule group."
        },
        group_delete: {
            permission: (0, perms_1.Shift)(5),
            description: "Allows a user to delete a schedule group."
        },
        group_edit: {
            permission: (0, perms_1.Shift)(6),
            description: "Allows a user to edit a schedule group."
        },
        group_view: {
            permission: (0, perms_1.Shift)(7),
            description: "Allows a user to view the schedule group list page."
        },
        view: {
            permission: (0, perms_1.Shift)(2),
            description: "Allows a user to view schedules that they are assigned to."
        },
        // view_manager: {
        //     permission: Shift(4),
        //     description: "Allows a user to view the Manager schedule."
        // },
        view_all: {
            permission: (0, perms_1.Shift)(3),
            description: "Allows a user to view all schedules for all terminals."
        }
    },
    terminal: {
        all: {
            permission: (0, perms_1.Shift)(exports.MAX_BITS),
            description: "Grants a user all Terminal related permissions."
        },
        create: {
            permission: (0, perms_1.Shift)(0),
            description: "Allows a user to create a terminal."
        },
        delete: {
            permission: (0, perms_1.Shift)(1),
            description: "Allows a user to delete (or de-activate) a terminal."
        },
        edit: {
            permission: (0, perms_1.Shift)(2),
            description: "Allows a user to edit a terminal."
        },
        view: {
            permission: (0, perms_1.Shift)(3),
            description: "Allows a user to view the terminal list page."
        }
    },
    work_order: {
        all: {
            permission: (0, perms_1.Shift)(exports.MAX_BITS),
            description: "Grants a user all Work Order related permissions."
        },
        create: {
            permission: (0, perms_1.Shift)(0),
            description: "Allows a user to create a work order.",
        },
        delete: {
            permission: (0, perms_1.Shift)(1),
            description: "Allows a user to delete a work order."
        },
        edit: {
            permission: (0, perms_1.Shift)(2),
            description: "Allows a user to edit a work order. Required to make any changes to a work order (adding notes, changing status, etc.)."
        },
        view_all: {
            permission: (0, perms_1.Shift)(3),
            description: "Allows a user to view all work orders."
        },
        view: {
            permission: (0, perms_1.Shift)(8),
            description: "Allows a user to view their submitted work orders."
        },
        supplier_create: {
            permission: (0, perms_1.Shift)(4),
            description: "Allows a user to create a supplier."
        },
        supplier_delete: {
            permission: (0, perms_1.Shift)(5),
            description: "Allows a user to delete a supplier."
        },
        supplier_edit: {
            permission: (0, perms_1.Shift)(6),
            description: "Allows a user to edit a supplier."
        },
        supplier_view: {
            permission: (0, perms_1.Shift)(7),
            description: "Allows a user to view suppliers."
        }
    }
};
class DigiTrakRole extends perms_1.Role {
    administrator;
    constructor(name = null, authority = null, permissions, override = null, administrator = null) {
        super();
        this.administrator = administrator;
        this.name = name;
        this.permissions = permissions;
        this.override = override;
        this.authority = authority;
    }
    has = (perm) => {
        return ((BigInt(this.permissions) & BigInt(perm)) === BigInt(perm))
            || (this.override !== null
                ? ((BigInt(this.permissions) & BigInt(this.override)) === BigInt(this.override))
                : false) || (this.administrator !== null
            ? ((BigInt(this.administrator) & BigInt(this.override)) === BigInt(this.override))
            : false);
    };
    static addPermission = (perms, permsToAdd) => {
        if (!perms)
            return permsToAdd;
        if (!permsToAdd)
            return perms;
        return Number(BigInt(perms) | BigInt(permsToAdd));
    };
    static removePermission = (perms, permsToRemove) => {
        if (!perms)
            return 0;
        if (!permsToRemove)
            return perms;
        return Number(BigInt(perms) & ~BigInt(permsToRemove));
    };
}
exports.DigiTrakRole = DigiTrakRole;
/**
 * Function that takes in role object with permissions that have keys corresponding to the high-level permissions ("approve", "work_orders", etc) and values corresponding to numerical permissions, and returns
 * returns an object of the same keys (plus any missing keys) with values of DigiTrakRole - allowing for any permission or authority checks.
 * @param role
 * @returns {PermissionGroup}
 */
const ParseRolePermissions = (role) => {
    return Object.keys(PermissionGroupEnum).reduce((acc, curr) => {
        return (acc[curr] = new DigiTrakRole(curr, role.authority ?? null, role?.permissions[curr] ?? 0, (0, perms_1.Shift)(exports.MAX_BITS), role.permissions?.administrator ?? null), acc);
    }, {});
};
exports.ParseRolePermissions = ParseRolePermissions;
